import type { FC, ReactNode } from "react";

type SwitchProps = {
  test: string;
  children: ReactNode[];
};

export const Switch: FC<SwitchProps> = ({ test, children }) => {
  return (
    (children as JSX.Element[]).find((child) => {
      return child?.props["value"] === test;
    }) || null
  );
};
